import PropTypes from 'prop-types';

import NavigationDefault from './NavigationDefault';
import NavigationSticky from './NavigationSticky';

import { CtfNavigationStyle } from '@/utils/constants';

function Navigation({
  fields,
  entries = [],
  assets = [],
  hasBackground = false,
  hasBreadcrumbs,
  hideLogo,
  isBlock,
  slug,
  tags,
}) {
  const style = fields?.navigationStyle || CtfNavigationStyle.DEFAULT;

  if (style === CtfNavigationStyle.STICKY) {
    return (
      <NavigationSticky
        fields={fields}
        assets={assets}
        entries={entries}
        slug={slug}
        tags={tags}
        hideLogo={hideLogo}
        hasBreadcrumbs={hasBreadcrumbs}
      />
    );
  }


  return (
    <NavigationDefault
      fields={fields}
      assets={assets}
      entries={entries}
      hasBackground={hasBackground}
      isBlock={isBlock}
      slug={slug}
      tags={tags}
      hideLogo={hideLogo}
    />
  );
}

// @TODO: define real props for the Navigation based on it requirements
Navigation.propTypes = {
  fields: PropTypes.object,
  entries: PropTypes.array,
  assets: PropTypes.array,
  hasBackground: PropTypes.bool,
  hideLogo: PropTypes.bool,
  isBlock: PropTypes.bool,
  tags: PropTypes.array,
  slug: PropTypes.string,
};

export default Navigation;
